/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceFilter extends models.ServiceResourceBaseFilter {
    getFixupPrototypeFunction() { return ServiceResourceFilter.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceFilter>): ServiceResourceFilter {
        let obj = Object.assign(new ServiceResourceFilter(), model);
        ServiceResourceFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceFilter>): ServiceResourceFilter {
        if (!model) return null;
        return ServiceResourceFilter.newInstance(<ServiceResourceFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceFilter) {
        if (!obj) return;

        models.ServiceResourceFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceFilter): boolean {
        if (models.ServiceResourceBaseFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceResourceFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Filter by resource
     */
    resource: string;

}
